const NoAccess = () => {
    return (
        <>
            <p style={{ padding: 20, textAlign: "center" }}>You don't have access to this page. Please contact your administrator.</p>
        </>
    );
};

export default NoAccess;